/**
 * Category color palette — shades of the Tellet green.
 *
 * Avoids reds, pinks, ambers and other hues that carry positive/negative
 * connotations in qualitative research. All 30 swatches sit within the
 * green-teal spectrum so the category chart reads as a neutral data
 * visualisation rather than a value judgement.
 *
 * Ordered light → dark so adjacent categories get visually distinct
 * shades when the list is consumed sequentially.
 */
const categoriesColorList = [
  '#096846', // Tellet primary
  '#96C89E', // Tellet secondary
  '#075539', // darker primary
  '#6BBF8A', // medium green
  '#0D6B4F', // pine
  '#4CAF6E', // fresh green
  '#1E8C46', // forest
  '#7EC8A0', // spring green
  '#2E9E52', // kelly green
  '#5AB87D', // leaf
  '#117A5C', // evergreen
  '#3DA85F', // grass
  '#0A5C42', // deep emerald
  '#8FD4A8', // seafoam
  '#339A5C', // shamrock
  '#6FC28E', // clover
  '#28A661', // emerald
  '#A8D5BA', // soft sage
  '#4FAE74', // jade
  '#80CCA3', // muted teal
  '#3BAC70', // fern
  '#5CBB88', // meadow
  '#50B982', // viridian
  '#A0D9B8', // celadon
  '#148F5E', // spring forest
  '#7DCAA0', // pistachio
  '#1B7A4A', // deep leaf
  '#B0C9B8', // grey sage
  '#246B42', // dark clover
  '#90BFA0', // dusty mint
];

/**
 * Return a green palette color for a given index. Wraps around
 * the list so any number of categories gets a distinct shade.
 */
export function getCategoryColor(index: number): string {
  return categoriesColorList[index % categoriesColorList.length];
}

export default categoriesColorList;
